import { render, staticRenderFns } from "./anchorBtns.vue?vue&type=template&id=4a4ed9f2&scoped=true&"
import script from "./anchorBtns.vue?vue&type=script&lang=js&"
export * from "./anchorBtns.vue?vue&type=script&lang=js&"
import style0 from "./anchorBtns.vue?vue&type=style&index=0&id=4a4ed9f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ed9f2",
  null
  
)

export default component.exports